import React, { useState, useEffect, useCallback } from 'react';

const API_URL = '';

function authFetch(url, opts) {
  const token = localStorage.getItem('wc_token');
  return fetch(url, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      ...(opts && opts.headers ? opts.headers : {}),
      ...(token ? { Authorization: 'Bearer ' + token } : {})
    }
  });
}

const ESTADOS_LEAD = [
  'lead_nuevo', 'contactado', 'en_conversacion', 'datos_incompletos',
  'cobertura_pendiente', 'cobertura_ok', 'cerca_de_red',
  'sin_cobertura_expansion', 'sin_cobertura',
  'propuesta_enviada', 'seguimiento',
  'precio_no_sirve', 'lo_piensa', 'no_responde', 'reagendar', 'competencia',
  'venta_confirmada', 'instalacion_pendiente', 'instalado',
  'cliente_activo', 'perdido'
];

const ESTADO_COLORS = {
  lead_nuevo: '#3b82f6',
  contactado: '#06b6d4',
  en_conversacion: '#22c55e',
  datos_incompletos: '#f59e0b',
  cobertura_pendiente: '#f59e0b',
  cobertura_ok: '#22c55e',
  cerca_de_red: '#06b6d4',
  sin_cobertura_expansion: '#8b5cf6',
  sin_cobertura: '#f59e0b',
  propuesta_enviada: '#3b82f6',
  seguimiento: '#f59e0b',
  precio_no_sirve: '#ef4444',
  lo_piensa: '#eab308',
  no_responde: '#6b7280',
  reagendar: '#8b5cf6',
  competencia: '#dc2626',
  venta_confirmada: '#22c55e',
  instalacion_pendiente: '#06b6d4',
  instalado: '#22c55e',
  cliente_activo: '#16a34a',
  perdido: '#374151'
};

const ESTADO_LABELS = {
  lead_nuevo: 'Lead Nuevo',
  contactado: 'Contactado',
  en_conversacion: 'En Conversación',
  datos_incompletos: 'Datos Incompletos',
  cobertura_pendiente: 'Cobertura Pendiente',
  cobertura_ok: 'Cobertura OK',
  cerca_de_red: 'Cerca de Red',
  sin_cobertura_expansion: 'Sin Cobertura (Expansión)',
  sin_cobertura: 'Sin Cobertura',
  propuesta_enviada: 'Propuesta Enviada',
  seguimiento: 'Seguimiento',
  precio_no_sirve: 'Precio No Sirve',
  lo_piensa: 'Lo Piensa',
  no_responde: 'No Responde',
  reagendar: 'Reagendar',
  competencia: 'Competencia',
  venta_confirmada: 'Venta Confirmada',
  instalacion_pendiente: 'Instalación Pendiente',
  instalado: 'Instalado',
  cliente_activo: 'Cliente Activo',
  perdido: 'Perdido'
};

const FUENTE_LABELS = {
  meta: 'Meta Ads',
  instagram: 'Instagram',
  facebook: 'Facebook',
  google: 'Google Ads',
  landing: 'Landing',
  whatsapp: 'WhatsApp',
  whatsapp_directo: 'WhatsApp Directo',
  manual: 'Manual'
};

function MarketingPanel({ onVerChat }) {
  const [tab, setTab] = useState('dashboard');
  const [leads, setLeads] = useState([]);
  const [campanas, setCampanas] = useState([]);
  const [zonas, setZonas] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [showNewLead, setShowNewLead] = useState(false);
  const [showNewCampana, setShowNewCampana] = useState(false);
  const [showNewZona, setShowNewZona] = useState(false);

  const cargarDatos = useCallback(async () => {
    setLoading(true);
    try {
      var results = await Promise.all([
        authFetch(API_URL + '/api/marketing/leads').then(function(r) { return r.json(); }),
        authFetch(API_URL + '/api/marketing/campanas').then(function(r) { return r.json(); }),
        authFetch(API_URL + '/api/marketing/zonas').then(function(r) { return r.json(); }),
        authFetch(API_URL + '/api/marketing/dashboard').then(function(r) { return r.json(); })
      ]);
      if (results[0].ok) setLeads(results[0].leads || []);
      if (results[1].ok) setCampanas(results[1].campanas || []);
      if (results[2].ok) setZonas(results[2].zonas || []);
      if (results[3].ok) setStats(results[3].stats || null);
    } catch (e) {
      console.error('Error cargando marketing:', e);
    }
    setLoading(false);
  }, []);

  useEffect(function() { cargarDatos(); }, [cargarDatos]);

  var tabs = [
    { id: 'dashboard', label: 'Dashboard' },
    { id: 'leads', label: 'Leads (' + leads.length + ')' },
    { id: 'campanas', label: 'Campanas' },
    { id: 'zonas', label: 'Zonas' }
  ];

  return (
    <div className="marketing-page">
      <div className="marketing-header">
        <div>
          <h1 style={{ fontSize: 24, letterSpacing: '-0.03em', margin: '0 0 5px' }}>Marketing & Social Leads</h1>
          <p style={{ color: 'var(--muted-2)', margin: 0 }}>Gestion de leads desde Meta, Google, WhatsApp y landing pages</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="mkt-btn primary" onClick={function() { setShowNewLead(true); }}>+ Nuevo Lead</button>
          <button className="mkt-btn" onClick={cargarDatos} disabled={loading}>{loading ? 'Cargando...' : 'Actualizar'}</button>
        </div>
      </div>

      <div className="mkt-tabs">
        {tabs.map(function(t) {
          return (
            <button key={t.id} className={'mkt-tab ' + (tab === t.id ? 'active' : '')} onClick={function() { setTab(t.id); }}>
              {t.label}
            </button>
          );
        })}
      </div>

      {tab === 'dashboard' && <DashboardTab stats={stats} leads={leads} />}
      {tab === 'leads' && <LeadsTab leads={leads} onSelect={setSelectedLead} onReload={cargarDatos} onVerChat={onVerChat} />}
      {tab === 'campanas' && <CampanasTab campanas={campanas} showNew={showNewCampana} setShowNew={setShowNewCampana} onReload={cargarDatos} />}
      {tab === 'zonas' && <ZonasTab zonas={zonas} showNew={showNewZona} setShowNew={setShowNewZona} onReload={cargarDatos} />}

      {selectedLead && <LeadDetailModal lead={selectedLead} onClose={function() { setSelectedLead(null); }} onReload={cargarDatos} onVerChat={onVerChat} />}
      {showNewLead && <NewLeadModal onClose={function() { setShowNewLead(false); }} onReload={cargarDatos} />}
    </div>
  );
}

// ═══ DASHBOARD TAB ═══
function DashboardTab({ stats, leads }) {
  if (!stats) return <div style={{ padding: 20, color: 'var(--muted)' }}>Cargando metricas...</div>;

  var kpis = [
    { label: 'Total Leads', value: stats.total, color: 'var(--accent)' },
    { label: 'Cobertura OK', value: stats.cobertura_ok, color: 'var(--green)' },
    { label: 'Ventas', value: stats.ventas, color: 'var(--green)' },
    { label: 'Instalados', value: stats.instalados, color: 'var(--cyan)' },
    { label: 'Sin Cobertura', value: stats.sin_cobertura, color: 'var(--red)' }
  ];

  return (
    <div>
      <div className="mkt-kpis">
        {kpis.map(function(k) {
          return (
            <div key={k.label} className="mkt-kpi-card">
              <span className="mkt-kpi-label">{k.label}</span>
              <strong className="mkt-kpi-value" style={{ color: k.color }}>{k.value}</strong>
            </div>
          );
        })}
      </div>

      <div className="mkt-grid-2">
        <div className="mkt-card">
          <h3 className="mkt-card-title">Por Estado</h3>
          <div className="mkt-stat-list">
            {Object.entries(stats.por_estado || {}).map(function(entry) {
              return (
                <div key={entry[0]} className="mkt-stat-row">
                  <span className="mkt-dot" style={{ background: ESTADO_COLORS[entry[0]] || 'var(--muted)' }}></span>
                  <span className="mkt-stat-label">{entry[0].replace(/_/g, ' ')}</span>
                  <span className="mkt-stat-value">{entry[1]}</span>
                </div>
              );
            })}
            {Object.keys(stats.por_estado || {}).length === 0 && <div style={{ color: 'var(--muted)', fontSize: 12 }}>Sin datos</div>}
          </div>
        </div>

        <div className="mkt-card">
          <h3 className="mkt-card-title">Por Fuente</h3>
          <div className="mkt-stat-list">
            {Object.entries(stats.por_fuente || {}).map(function(entry) {
              return (
                <div key={entry[0]} className="mkt-stat-row">
                  <span className="mkt-stat-label">{FUENTE_LABELS[entry[0]] || entry[0]}</span>
                  <span className="mkt-stat-value">{entry[1]}</span>
                </div>
              );
            })}
            {Object.keys(stats.por_fuente || {}).length === 0 && <div style={{ color: 'var(--muted)', fontSize: 12 }}>Sin datos</div>}
          </div>
        </div>
      </div>

      <div className="mkt-card">
        <h3 className="mkt-card-title">Ultimos Leads</h3>
        <div className="mkt-table-wrap">
          <table className="mkt-table">
            <thead>
              <tr><th>Fecha</th><th>Nombre</th><th>Telefono</th><th>Fuente</th><th>Localidad</th><th>Estado</th></tr>
            </thead>
            <tbody>
              {leads.slice(0, 10).map(function(l) {
                return (
                  <tr key={l.id}>
                    <td>{l.created_at ? new Date(l.created_at).toLocaleDateString('es-AR') : '-'}</td>
                    <td>{l.nombre || '-'}</td>
                    <td>{l.telefono || '-'}</td>
                    <td><span className="mkt-badge">{FUENTE_LABELS[l.fuente] || l.fuente}</span></td>
                    <td>{l.localidad || '-'}</td>
                    <td><span className="mkt-badge" style={{ background: (ESTADO_COLORS[l.estado_lead] || 'var(--muted)') + '22', color: ESTADO_COLORS[l.estado_lead] || 'var(--muted)', border: '1px solid ' + (ESTADO_COLORS[l.estado_lead] || 'var(--muted)') + '44' }}>{(l.estado_lead || '').replace(/_/g, ' ')}</span></td>
                  </tr>
                );
              })}
              {leads.length === 0 && <tr><td colSpan="6" style={{ textAlign: 'center', color: 'var(--muted)' }}>No hay leads</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ═══ LEADS TAB ═══
function LeadsTab({ leads, onSelect, onReload, onVerChat }) {
  var [filtroEstado, setFiltroEstado] = useState('');
  var [filtroFuente, setFiltroFuente] = useState('');
  var [recontactando, setRecontactando] = useState(null);

  var filtered = leads.filter(function(l) {
    if (filtroEstado && l.estado_lead !== filtroEstado) return false;
    if (filtroFuente && l.fuente !== filtroFuente) return false;
    return true;
  });

  // Contar leads por estado (solo los que existen en los datos)
  var conteosPorEstado = {};
  leads.forEach(function(l) {
    var e = l.estado_lead || 'sin_estado';
    conteosPorEstado[e] = (conteosPorEstado[e] || 0) + 1;
  });

  // Chips: solo mostrar estados que tengan al menos 1 lead
  var chipsEstados = ESTADOS_LEAD.filter(function(e) { return conteosPorEstado[e] > 0; });

  async function validarCobertura(id) {
    try {
      var resp = await authFetch(API_URL + '/api/marketing/leads/' + id + '/validar-cobertura', { method: 'POST' });
      var data = await resp.json();
      alert(data.ok ? (data.cobertura ? 'Cobertura OK!' : 'Sin cobertura') : ('Error: ' + (data.error || '')));
      onReload();
    } catch (e) { alert('Error de conexion'); }
  }

  async function marcarPerdido(id) {
    var motivo = prompt('Motivo de perdida:');
    if (!motivo) return;
    try {
      await authFetch(API_URL + '/api/marketing/leads/' + id + '/marcar-perdido', { method: 'POST', body: JSON.stringify({ motivo: motivo }) });
      onReload();
    } catch (e) { alert('Error'); }
  }

  async function convertirConversacion(id) {
    try {
      var resp = await authFetch(API_URL + '/api/marketing/leads/' + id + '/convertir-a-conversacion', { method: 'POST' });
      var data = await resp.json();
      alert(data.ok ? 'Conversacion creada' : ('Error: ' + (data.error || '')));
      onReload();
    } catch (e) { alert('Error'); }
  }

  async function recontactar(id) {
    setRecontactando(id);
    try {
      var resp = await authFetch(API_URL + '/api/marketing/leads/' + id + '/convertir-a-conversacion', { method: 'POST' });
      var data = await resp.json();
      if (data.ok) {
        alert('Template enviado. La conversación se creó en el inbox de ventas.');
        onReload();
      } else {
        alert('Error: ' + (data.error || 'No se pudo recontactar'));
      }
    } catch (e) { alert('Error de conexion'); }
    setRecontactando(null);
  }

  return (
    <div>
      {/* ── Chips de filtro por estado ── */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
        <button
          className={'mkt-chip ' + (filtroEstado === '' ? 'active' : '')}
          onClick={function() { setFiltroEstado(''); }}
          style={{
            padding: '5px 12px', borderRadius: 20, fontSize: 12, fontWeight: 600,
            border: filtroEstado === '' ? '1px solid var(--accent)' : '1px solid var(--border-light)',
            background: filtroEstado === '' ? 'var(--accent)' + '22' : 'transparent',
            color: filtroEstado === '' ? 'var(--accent)' : 'var(--muted)',
            cursor: 'pointer', transition: 'all 0.15s',
          }}
        >
          Todos ({leads.length})
        </button>
        {chipsEstados.map(function(estado) {
          var color = ESTADO_COLORS[estado] || 'var(--muted)';
          var isActive = filtroEstado === estado;
          return (
            <button
              key={estado}
              onClick={function() { setFiltroEstado(isActive ? '' : estado); }}
              style={{
                padding: '5px 12px', borderRadius: 20, fontSize: 12, fontWeight: 500,
                border: isActive ? '1px solid ' + color : '1px solid var(--border-light)',
                background: isActive ? color + '22' : 'transparent',
                color: isActive ? color : 'var(--muted)',
                cursor: 'pointer', transition: 'all 0.15s',
              }}
            >
              {ESTADO_LABELS[estado] || estado.replace(/_/g, ' ')} ({conteosPorEstado[estado]})
            </button>
          );
        })}
      </div>

      {/* ── Filtro por fuente ── */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 14, alignItems: 'center' }}>
        <select className="mkt-select" value={filtroFuente} onChange={function(e) { setFiltroFuente(e.target.value); }}>
          <option value="">Todas las fuentes</option>
          {Object.entries(FUENTE_LABELS).map(function(entry) { return <option key={entry[0]} value={entry[0]}>{entry[1]}</option>; })}
        </select>
        <span style={{ color: 'var(--muted)', fontSize: 12 }}>{filtered.length} leads</span>
      </div>

      <div className="mkt-card">
        <div className="mkt-table-wrap">
          <table className="mkt-table">
            <thead>
              <tr><th>Fecha</th><th>Nombre</th><th>Teléfono</th><th>Fuente</th><th>Localidad</th><th>Estado</th><th>Motivo</th><th>Acciones</th></tr>
            </thead>
            <tbody>
              {filtered.map(function(l) {
                var esRecontactable = ['sin_cobertura', 'precio_no_sirve', 'lo_piensa', 'no_responde', 'reagendar', 'competencia'].includes(l.estado_lead);
                return (
                  <tr key={l.id}>
                    <td>{l.created_at ? new Date(l.created_at).toLocaleDateString('es-AR') : '-'}</td>
                    <td style={{ cursor: 'pointer', color: 'var(--accent)' }} onClick={function() { onSelect(l); }}>{l.nombre || '-'}</td>
                    <td>{l.telefono || '-'}</td>
                    <td><span className="mkt-badge">{FUENTE_LABELS[l.fuente] || l.fuente}</span></td>
                    <td>{l.localidad || '-'}</td>
                    <td><span className="mkt-badge" style={{ background: (ESTADO_COLORS[l.estado_lead] || 'var(--muted)') + '22', color: ESTADO_COLORS[l.estado_lead] || 'var(--muted)', border: '1px solid ' + (ESTADO_COLORS[l.estado_lead] || 'var(--muted)') + '44' }}>{ESTADO_LABELS[l.estado_lead] || (l.estado_lead || '').replace(/_/g, ' ')}</span></td>
                    <td style={{ fontSize: 11, color: 'var(--muted)' }}>{l.motivo_cierre ? l.motivo_cierre.replace(/_/g, ' ') : '-'}</td>
                    <td>
                      <div style={{ display: 'flex', gap: 4 }}>
                        <button className="mkt-btn-sm" onClick={function() { onSelect(l); }}>Ver</button>
                        {esRecontactable && (
                          <button
                            className="mkt-btn-sm primary"
                            disabled={recontactando === l.id}
                            onClick={function() { recontactar(l.id); }}
                          >
                            {recontactando === l.id ? '...' : '📩 Recontactar'}
                          </button>
                        )}
                        {!esRecontactable && l.estado_lead !== 'cliente_activo' && l.estado_lead !== 'perdido' && (
                          <button className="mkt-btn-sm" onClick={function() { convertirConversacion(l.id); }}>Conversación</button>
                        )}
                        {onVerChat && l.telefono && (
                          <button className="mkt-btn-sm" style={{ background: '#3b82f622', color: '#60a5fa', border: '1px solid #3b82f644' }} onClick={function() { onVerChat(l.telefono); }}>💬 Chat</button>
                        )}
                        <button className="mkt-btn-sm" onClick={function() { validarCobertura(l.id); }}>Cobertura</button>
                        {l.estado_lead !== 'perdido' && l.estado_lead !== 'cliente_activo' && (
                          <button className="mkt-btn-sm danger" onClick={function() { marcarPerdido(l.id); }}>Perdido</button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
              {filtered.length === 0 && <tr><td colSpan="8" style={{ textAlign: 'center', color: 'var(--muted)' }}>No hay leads</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ═══ CAMPANAS TAB ═══
function CampanasTab({ campanas, showNew, setShowNew, onReload }) {
  async function crearCampana(e) {
    e.preventDefault();
    var form = e.target;
    var body = {
      plataforma: form.plataforma.value,
      campaign_name: form.campaign_name.value,
      objetivo: form.objetivo.value,
      producto: form.producto.value,
      localidad: form.localidad.value
    };
    try {
      await authFetch(API_URL + '/api/marketing/campanas', { method: 'POST', body: JSON.stringify(body) });
      setShowNew(false);
      onReload();
    } catch (err) { alert('Error'); }
  }

  return (
    <div>
      <div style={{ marginBottom: 14 }}>
        <button className="mkt-btn primary" onClick={function() { setShowNew(!showNew); }}>{showNew ? 'Cancelar' : '+ Nueva Campana'}</button>
      </div>

      {showNew && (
        <div className="mkt-card" style={{ marginBottom: 14 }}>
          <form onSubmit={crearCampana} style={{ padding: 16, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
            <select name="plataforma" className="mkt-input" required><option value="meta">Meta</option><option value="google">Google</option></select>
            <input name="campaign_name" className="mkt-input" placeholder="Nombre campana" required />
            <select name="objetivo" className="mkt-input"><option value="mensajes">Mensajes</option><option value="leads">Leads</option><option value="search">Search</option><option value="remarketing">Remarketing</option></select>
            <select name="producto" className="mkt-input"><option value="internet">Internet</option><option value="internet_tv">Internet + TV</option><option value="tv">TV</option></select>
            <input name="localidad" className="mkt-input" placeholder="Localidad" />
            <button type="submit" className="mkt-btn primary">Guardar</button>
          </form>
        </div>
      )}

      <div className="mkt-card">
        <div className="mkt-table-wrap">
          <table className="mkt-table">
            <thead>
              <tr><th>Campana</th><th>Plataforma</th><th>Objetivo</th><th>Producto</th><th>Localidad</th><th>Estado</th><th>Creada</th></tr>
            </thead>
            <tbody>
              {campanas.map(function(c) {
                return (
                  <tr key={c.id}>
                    <td style={{ fontWeight: 600 }}>{c.campaign_name}</td>
                    <td><span className="mkt-badge">{c.plataforma === 'meta' ? 'Meta' : 'Google'}</span></td>
                    <td>{c.objetivo || '-'}</td>
                    <td>{c.producto || '-'}</td>
                    <td>{c.localidad || '-'}</td>
                    <td><span className="mkt-badge" style={{ background: c.estado === 'activa' ? 'var(--green-soft)' : 'var(--red-soft)', color: c.estado === 'activa' ? 'var(--green)' : 'var(--red)' }}>{c.estado}</span></td>
                    <td>{c.created_at ? new Date(c.created_at).toLocaleDateString('es-AR') : '-'}</td>
                  </tr>
                );
              })}
              {campanas.length === 0 && <tr><td colSpan="7" style={{ textAlign: 'center', color: 'var(--muted)' }}>No hay campanas</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ═══ ZONAS TAB ═══
function ZonasTab({ zonas, showNew, setShowNew, onReload }) {
  var estadoRedColors = {
    cobertura_ok: 'var(--green)',
    cerca_de_red: 'var(--cyan)',
    expansion: 'var(--purple)',
    sin_cobertura: 'var(--red)',
    saturada: 'var(--amber)'
  };

  async function crearZona(e) {
    e.preventDefault();
    var form = e.target;
    var body = {
      localidad: form.localidad.value,
      barrio: form.barrio.value,
      zona_nombre: form.zona_nombre.value,
      estado_red: form.estado_red.value,
      prioridad: parseInt(form.prioridad.value) || 1,
      observacion: form.observacion.value
    };
    try {
      await authFetch(API_URL + '/api/marketing/zonas', { method: 'POST', body: JSON.stringify(body) });
      setShowNew(false);
      onReload();
    } catch (err) { alert('Error'); }
  }

  return (
    <div>
      <div style={{ marginBottom: 14 }}>
        <button className="mkt-btn primary" onClick={function() { setShowNew(!showNew); }}>{showNew ? 'Cancelar' : '+ Nueva Zona'}</button>
      </div>

      {showNew && (
        <div className="mkt-card" style={{ marginBottom: 14 }}>
          <form onSubmit={crearZona} style={{ padding: 16, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
            <input name="localidad" className="mkt-input" placeholder="Localidad" required />
            <input name="barrio" className="mkt-input" placeholder="Barrio" />
            <input name="zona_nombre" className="mkt-input" placeholder="Nombre zona" />
            <select name="estado_red" className="mkt-input" required><option value="cobertura_ok">Cobertura OK</option><option value="cerca_de_red">Cerca de red</option><option value="expansion">Expansion</option><option value="sin_cobertura">Sin cobertura</option><option value="saturada">Saturada</option></select>
            <select name="prioridad" className="mkt-input"><option value="1">Prioridad 1 (alta)</option><option value="2">Prioridad 2</option><option value="3">Prioridad 3 (baja)</option></select>
            <input name="observacion" className="mkt-input" placeholder="Observacion" />
            <button type="submit" className="mkt-btn primary">Guardar</button>
          </form>
        </div>
      )}

      <div className="mkt-card">
        <div className="mkt-table-wrap">
          <table className="mkt-table">
            <thead>
              <tr><th>Localidad</th><th>Barrio</th><th>Zona</th><th>Estado Red</th><th>Prioridad</th><th>Observacion</th></tr>
            </thead>
            <tbody>
              {zonas.map(function(z) {
                return (
                  <tr key={z.id}>
                    <td style={{ fontWeight: 600 }}>{z.localidad}</td>
                    <td>{z.barrio || '-'}</td>
                    <td>{z.zona_nombre || '-'}</td>
                    <td><span className="mkt-badge" style={{ color: estadoRedColors[z.estado_red] || 'var(--muted)' }}>{(z.estado_red || '').replace(/_/g, ' ')}</span></td>
                    <td>{z.prioridad}</td>
                    <td>{z.observacion || '-'}</td>
                  </tr>
                );
              })}
              {zonas.length === 0 && <tr><td colSpan="6" style={{ textAlign: 'center', color: 'var(--muted)' }}>No hay zonas</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ═══ LEAD DETAIL MODAL ═══
function LeadDetailModal({ lead, onClose, onReload, onVerChat }) {
  var [eventos, setEventos] = useState([]);

  useEffect(function() {
    authFetch(API_URL + '/api/marketing/leads/' + lead.id)
      .then(function(r) { return r.json(); })
      .then(function(data) { if (data.ok) setEventos(data.eventos || []); });
  }, [lead.id]);

  async function cambiarEstado(nuevoEstado) {
    try {
      await authFetch(API_URL + '/api/marketing/leads/' + lead.id, { method: 'PATCH', body: JSON.stringify({ estado_lead: nuevoEstado }) });
      onReload();
      onClose();
    } catch (e) { alert('Error'); }
  }

  async function confirmarVenta() {
    try {
      await authFetch(API_URL + '/api/marketing/leads/' + lead.id + '/confirmar-venta', { method: 'POST' });
      onReload();
      onClose();
    } catch (e) { alert('Error'); }
  }

  async function marcarInstalado() {
    try {
      await authFetch(API_URL + '/api/marketing/leads/' + lead.id + '/marcar-instalado', { method: 'POST' });
      onReload();
      onClose();
    } catch (e) { alert('Error'); }
  }

  return (
    <div className="mkt-modal-overlay" onClick={onClose}>
      <div className="mkt-modal" onClick={function(e) { e.stopPropagation(); }}>
        <div className="mkt-modal-header">
          <h2>Lead: {lead.nombre || 'Sin nombre'}</h2>
          <button className="mkt-btn-close" onClick={onClose}>X</button>
        </div>

        <div className="mkt-modal-body">
          <div className="mkt-detail-grid">
            <div className="mkt-detail-item"><span>Telefono</span><strong>{lead.telefono || '-'}</strong></div>
            <div className="mkt-detail-item"><span>Email</span><strong>{lead.email || '-'}</strong></div>
            <div className="mkt-detail-item"><span>Fuente</span><strong>{FUENTE_LABELS[lead.fuente] || lead.fuente}</strong></div>
            <div className="mkt-detail-item"><span>Canal</span><strong>{lead.canal || '-'}</strong></div>
            <div className="mkt-detail-item"><span>Localidad</span><strong>{lead.localidad || '-'}</strong></div>
            <div className="mkt-detail-item"><span>Direccion</span><strong>{lead.direccion || '-'}</strong></div>
            <div className="mkt-detail-item"><span>Plan interes</span><strong>{lead.plan_interes || '-'}</strong></div>
            <div className="mkt-detail-item"><span>Cobertura</span><strong>{(lead.estado_cobertura || 'pendiente').replace(/_/g, ' ')}</strong></div>
            <div className="mkt-detail-item"><span>Campana</span><strong>{lead.campaign_name || '-'}</strong></div>
            <div className="mkt-detail-item"><span>Anuncio</span><strong>{lead.ad_name || '-'}</strong></div>
            <div className="mkt-detail-item"><span>Estado</span><strong style={{ color: ESTADO_COLORS[lead.estado_lead] || 'var(--muted)' }}>{(lead.estado_lead || '').replace(/_/g, ' ')}</strong></div>
            <div className="mkt-detail-item"><span>Creado</span><strong>{lead.created_at ? new Date(lead.created_at).toLocaleString('es-AR') : '-'}</strong></div>
          </div>

          {lead.utm_source && (
            <div style={{ marginTop: 12, padding: 10, background: 'var(--card)', borderRadius: 8, fontSize: 11 }}>
              <strong>UTMs:</strong> source={lead.utm_source} | medium={lead.utm_medium} | campaign={lead.utm_campaign}
              {lead.gclid && <span> | gclid={lead.gclid}</span>}
              {lead.fbclid && <span> | fbclid={lead.fbclid}</span>}
            </div>
          )}

          <div style={{ marginTop: 14 }}>
            <h3 style={{ fontSize: 14, marginBottom: 8 }}>Acciones</h3>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              <button className="mkt-btn primary" onClick={confirmarVenta}>Confirmar Venta</button>
              {onVerChat && lead.telefono && (
                <button className="mkt-btn" style={{ background: '#3b82f622', color: '#60a5fa', border: '1px solid #3b82f644' }} onClick={function() { onVerChat(lead.telefono); onClose(); }}>💬 Ver Chat</button>
              )}
              <button className="mkt-btn" onClick={marcarInstalado}>Marcar Instalado</button>
              <button className="mkt-btn" onClick={function() { cambiarEstado('seguimiento'); }}>Seguimiento</button>
              <button className="mkt-btn" onClick={function() { cambiarEstado('propuesta_enviada'); }}>Propuesta Enviada</button>
              <button className="mkt-btn danger" onClick={function() { cambiarEstado('perdido'); }}>Perdido</button>
            </div>
          </div>

          {eventos.length > 0 && (
            <div style={{ marginTop: 14 }}>
              <h3 style={{ fontSize: 14, marginBottom: 8 }}>Timeline</h3>
              <div className="mkt-timeline">
                {eventos.map(function(ev) {
                  return (
                    <div key={ev.id} className="mkt-timeline-item">
                      <span className="mkt-timeline-dot" style={{ background: ESTADO_COLORS[ev.tipo_evento] || 'var(--accent)' }}></span>
                      <div>
                        <strong>{(ev.tipo_evento || '').replace(/_/g, ' ')}</strong>
                        <p>{ev.descripcion || ''}</p>
                        <span className="mkt-timeline-time">{ev.created_at ? new Date(ev.created_at).toLocaleString('es-AR') : ''}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ═══ NEW LEAD MODAL ═══
function NewLeadModal({ onClose, onReload }) {
  async function crear(e) {
    e.preventDefault();
    var form = e.target;
    var body = {
      fuente: form.fuente.value,
      canal: form.canal.value || null,
      nombre: form.nombre.value,
      telefono: form.telefono.value,
      email: form.email_field.value || null,
      localidad: form.localidad.value || null,
      direccion: form.direccion.value || null,
      plan_interes: form.plan_interes.value || null
    };
    try {
      var resp = await authFetch(API_URL + '/api/marketing/leads', { method: 'POST', body: JSON.stringify(body) });
      var data = await resp.json();
      if (data.ok) { onReload(); onClose(); }
      else alert('Error: ' + (data.error || ''));
    } catch (err) { alert('Error de conexion'); }
  }

  return (
    <div className="mkt-modal-overlay" onClick={onClose}>
      <div className="mkt-modal" onClick={function(e) { e.stopPropagation(); }}>
        <div className="mkt-modal-header">
          <h2>Nuevo Lead</h2>
          <button className="mkt-btn-close" onClick={onClose}>X</button>
        </div>
        <form onSubmit={crear} className="mkt-modal-body">
          <div className="mkt-form-grid">
            <div><label>Fuente *</label><select name="fuente" className="mkt-input" required><option value="manual">Manual</option><option value="whatsapp">WhatsApp</option><option value="meta">Meta Ads</option><option value="google">Google Ads</option><option value="landing">Landing</option></select></div>
            <div><label>Canal</label><select name="canal" className="mkt-input"><option value="">-</option><option value="whatsapp">WhatsApp</option><option value="formulario_meta">Formulario Meta</option><option value="landing">Landing</option><option value="instagram_dm">Instagram DM</option></select></div>
            <div><label>Nombre *</label><input name="nombre" className="mkt-input" required /></div>
            <div><label>Telefono *</label><input name="telefono" className="mkt-input" required /></div>
            <div><label>Email</label><input name="email_field" className="mkt-input" type="email" /></div>
            <div><label>Localidad</label><input name="localidad" className="mkt-input" /></div>
            <div><label>Direccion</label><input name="direccion" className="mkt-input" /></div>
            <div><label>Plan interes</label><select name="plan_interes" className="mkt-input"><option value="">-</option><option value="100mb">100 Mb</option><option value="300mb">300 Mb</option><option value="600mb">600 Mb</option></select></div>
          </div>
          <div style={{ marginTop: 14, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button type="button" className="mkt-btn" onClick={onClose}>Cancelar</button>
            <button type="submit" className="mkt-btn primary">Crear Lead</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default React.memo(MarketingPanel);
